import React, { useState, useEffect } from 'react';
import { Box, Paper, Button,IconButton, Tooltip, Typography, Zoom } from '@mui/material';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import ContrastIcon from '@mui/icons-material/Contrast';
import TextIncreaseIcon from '@mui/icons-material/TextIncrease';
import TextDecreaseIcon from '@mui/icons-material/TextDecrease';
import TextFormatIcon from '@mui/icons-material/TextFormat';
import CloseIcon from '@mui/icons-material/Close';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { useNavigate } from 'react-router-dom';

export default function AcessibilidadeFlutuante() {
    const [open, setOpen] = useState(false);
    const [altoContraste, setAltoContraste] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const contrasteSalvo = localStorage.getItem('altoContraste') === 'true';
        if (contrasteSalvo) {
            document.documentElement.classList.add('alto-contrast-mode');
            setAltoContraste(true);
        }
    }, []);

    const toggleContraste = () => {
        const novoContraste = !altoContraste;
        setAltoContraste(novoContraste);
        if (novoContraste) {
            document.documentElement.classList.add('alto-contrast-mode');
            localStorage.setItem('altoContraste', 'true');
        } else {
            document.documentElement.classList.remove('alto-contrast-mode');
            localStorage.setItem('altoContraste', 'false');
        }
    };

    const alterarFonte = (acao) => {
        const html = document.documentElement;
        const tamanhoAtual = parseFloat(window.getComputedStyle(html).fontSize);

        if (acao === 'aumentar' && tamanhoAtual < 24) {
            html.style.fontSize = `${tamanhoAtual + 2}px`;
        } else if (acao === 'diminuir' && tamanhoAtual > 12) {
            html.style.fontSize = `${tamanhoAtual - 2}px`;
        } else if (acao === 'normal') {
            html.style.fontSize = '';
        }
    };

    return (
        <Box
            className="acessibilidade-ignore" /* CLASSE ADICIONADA AQUI */
            sx={{
                position: 'fixed',
                left: 20,
                top: '45%',
                transform: 'translateY(-45%)',
                zIndex: 99999
            }}
        >
            {/* Ícone Redondo Flutuante */}
            {!open && (
                <Tooltip title="Acessibilidade" placement="right" arrow>
                    <IconButton
                        onClick={() => setOpen(true)}
                        sx={{
                            backgroundColor: '#1a202c',
                            color: '#fff',
                            boxShadow: '0px 4px 14px rgba(0,0,0,0.3)',
                            width: 52,
                            height: 52,
                            border: '1px solid #4a5568',
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                                backgroundColor: '#2d3748',
                                transform: 'scale(1.08)'
                            }
                        }}
                    >
                        <AccessibilityIcon sx={{ fontSize: 26 }} />
                    </IconButton>
                </Tooltip>
            )}

            {/* Painel de Opções Completo */}
            <Zoom in={open}>
                <Paper
                    elevation={6}
                    sx={{
                        display: open ? 'flex' : 'none',
                        flexDirection: 'column',
                        width: 240,
                        backgroundColor: '#1a202c',
                        color: '#fff',
                        borderRadius: 3,
                        p: 2.5,
                        border: '1px solid #2d3748',
                        boxShadow: '0px 8px 24px rgba(0,0,0,0.4)',
                    }}
                >
                    {/* Cabeçalho do Painel */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2.5 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1, fontSize: '0.85rem', letterSpacing: 0.5 }}>
                            <AccessibilityIcon fontSize="small" sx={{ color: '#63b3ed' }} /> ACESSIBILIDADE
                        </Typography>
                        <IconButton size="small" onClick={() => setOpen(false)} sx={{ color: '#a0aec0', '&:hover': { color: '#fff' } }}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>

                    {/* Ajuste de Texto */}
                    <Typography variant="caption" sx={{ color: '#a0aec0', mb: 1, fontWeight: 600, display: 'block', textTransform: 'uppercase', fontSize: '0.65rem', letterSpacing: 0.5 }}>
                        Tamanho do Texto
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
                        <Tooltip title="Diminuir Texto" arrow>
                            <IconButton size="medium" onClick={() => alterarFonte('diminuir')} sx={{ border: '1px solid #4a5568', color: '#fff', flex: 1, borderRadius: 1.5, '&:hover': { backgroundColor: '#2d3748' } }}>
                                <TextDecreaseIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Tamanho Padrão" arrow>
                            <IconButton size="medium" onClick={() => alterarFonte('normal')} sx={{ border: '1px solid #4a5568', color: '#fff', flex: 1, borderRadius: 1.5, '&:hover': { backgroundColor: '#2d3748' } }}>
                                <TextFormatIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Aumentar Texto" arrow>
                            <IconButton size="medium" onClick={() => alterarFonte('aumentar')} sx={{ border: '1px solid #4a5568', color: '#fff', flex: 1, borderRadius: 1.5, '&:hover': { backgroundColor: '#2d3748' } }}>
                                <TextIncreaseIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>

                    {/* Botão de Alternância de Alto Contraste */}
                    <Typography variant="caption" sx={{ color: '#a0aec0', mb: 1, fontWeight: 600, display: 'block', textTransform: 'uppercase', fontSize: '0.65rem', letterSpacing: 0.5 }}>
                        Aparência Visual
                    </Typography>
                    <IconButton
                        onClick={toggleContraste}
                        sx={{
                            border: '1px solid #3182ce',
                            backgroundColor: '#3182ce',
                            color: '#fff',
                            borderRadius: 1.5,
                            py: 1.2,
                            fontSize: '0.8rem',
                            fontWeight: 700,
                            display: 'flex',
                            gap: 1,
                            justifyContent: 'center',
                            width: '100%',
                            mb: 3,
                            transition: 'all 0.2s',
                            '&:hover': {
                                backgroundColor: '#2b6cb0',
                                borderColor: '#2b6cb0'
                            }
                        }}
                    >
                        <ContrastIcon fontSize="small" />
                        {altoContraste ? 'Modo Normal' : 'Alto Contraste'}
                    </IconButton>
                    <Button
                        variant="outlined"
                        color="inherit"
                        startIcon={<AccountTreeIcon />}
                        onClick={() => navigate('/mapadosite')}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 500,
                            borderRadius: '8px',
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                                transform: 'scale(1.02)',
                            }
                        }}
                    >
                        Mapa do Site
                    </Button>

                    {/* Assinatura Corporativa */}
                    <Box sx={{ mt: 'auto', textAlign: 'center', pt: 1.5, borderTop: '1px solid #2d3748' }}>
                        <Typography variant="caption" sx={{ color: '#718096', fontSize: '9px', letterSpacing: 0.8, fontWeight: 700, textTransform: 'uppercase', display: 'block' }}>
                            Desenvolvido por
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#63b3ed', fontWeight: 800, fontSize: '11px', mt: 0.2, letterSpacing: 0.5 }}>
                            BIGSTAR SOFTWARES
                        </Typography>
                    </Box>
                </Paper>
            </Zoom>
        </Box>
    );
}